export const getAuthPayload = (response) => response?.data || response || {}

export const getAccessTokenFromAuthPayload = (payload) => payload?.token?.accessToken || payload?.accessToken || ''

export const getUserFromAuthPayload = (payload) => payload?.user

export const getClubFromAuthPayload = (payload) => payload?.club
